import { jsx as _jsx } from "preact/jsx-runtime";
import HomeRecyclingStartPage from './home-recycling.page';
import MaterialStartPage from './material.page';
import NotFoundPage from './not-found.page';
import startAction, { homeRecyclingStartAction, materialStartAction, } from './start.action';
import startLoader from './start.loader';
import StartPage from './start.page';
const routes = [
    {
        path: '/',
        element: _jsx(StartPage, {}),
        action: startAction,
        loader: startLoader,
        errorElement: _jsx(NotFoundPage, {}),
    },
    {
        path: '/home-recycling',
        element: _jsx(HomeRecyclingStartPage, {}),
        action: homeRecyclingStartAction,
        loader: startLoader,
        errorElement: _jsx(NotFoundPage, {}),
    },
    {
        path: '/material',
        element: _jsx(MaterialStartPage, {}),
        action: materialStartAction,
        loader: startLoader,
        errorElement: _jsx(NotFoundPage, {}),
    },
];
export default routes;
